// components/CampuCourseAccess.jsx
import React from "react";
import { TextField, MenuItem } from "@material-ui/core";

/** Opzioni di accesso corso */
const ACCESS_OPTIONS = [
  { value: "", label: "" }, // vuoto
  { value: "national", label: "Nazionale" },
  { value: "local", label: "Locale" },
  { value: "free", label: "Accesso libero" },
  { value: "portfolio-test", label: "Portfolio e Test d'ingresso" },
  { value: "free-aptitude", label: "Libero con test di orientamento" },
];

/**
 * CampuCourseAccess
 * Dropdown a scelta unica per il tipo di accesso del corso.
 *
 * Props:
 * - value: string (può essere "")
 * - onChange: function (riceve l'evento come un normale TextField)
 * - label?: string (default: "Accesso")
 * - name?: string (default: "course_access")
 * - margin?: 'none' | 'dense' | 'normal' (default: 'dense')
 * - variant?: 'standard' | 'outlined' | 'filled' (default: 'standard')
 * - fullWidth?: boolean (default: true)
 * - disabled?: boolean
 * - error?: boolean
 * - helperText?: string
 */
export default function CampusCourseEntryMode({
  value,
  onChange,
  label = "Accesso",
  name = "course_access",
  margin = "dense",
  variant = "standard",
  fullWidth = true,
  disabled,
  error,
  helperText,
}) {
  const val = typeof value === "string" ? value : "";

  return (
    <TextField
      select
      name={name}
      label={label}
      value={val}
      onChange={onChange}
      margin={margin}
      variant={variant}
      fullWidth={fullWidth}
      disabled={disabled}
      error={error}
      helperText={helperText}
    >
      {ACCESS_OPTIONS.map((opt) => (
        <MenuItem key={opt.value || "empty"} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
